import axios from 'axios'

const baseUrl = process.env.API_BASE_URL

type UserData = {
  username: string
}

export const resendCode = ({ username }: UserData) =>
  axios.post(`${baseUrl}/resend-code`, {
    username: username,
  })
